import React from 'react';

import { Layers, ShieldCheck, Star } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';

export function StatsSection() {
  const { t } = useTranslation('home');

  const STATS_DATA = [
    {
      value: t('stats.items.satisfaction.value'),
      descriptionKey: 'home:stats.items.satisfaction.description',
      shortLabel: t('stats.items.satisfaction.shortLabel'),
      Icon: Star,
    },
    {
      value: t('stats.items.pricing.value'),
      descriptionKey: 'home:stats.items.pricing.description',
      shortLabel: t('stats.items.pricing.shortLabel'),
      Icon: ShieldCheck,
    },
    {
      value: t('stats.items.support.value'),
      descriptionKey: 'home:stats.items.support.description',
      shortLabel: t('stats.items.support.shortLabel'),
      Icon: Layers,
    },
  ] as const;

  return (
    <div className="w-full">
      {/* Desktop: 3 stats in a row */}
      <div className="hidden flex-col items-stretch justify-center gap-6 px-5 py-8 md:flex md:flex-row md:items-center md:gap-[150px] md:px-0 md:py-[50px]">
        {STATS_DATA.map((stat, index) => (
          <div key={index} className="flex items-center gap-4 md:gap-[28px]">
            <div className="flex items-center gap-[12px]">
              <h3 className="text-2xl font-bold leading-[1.3] tracking-[-0.022em] text-[#222222] md:text-[32px]">
                {stat.value}
              </h3>
            </div>

            <p className="text-sm font-normal leading-[1.5] tracking-[-0.022em] text-[#717171] md:text-[18px]">
              <Trans i18nKey={stat.descriptionKey} components={{ br: <br /> }} />
            </p>
          </div>
        ))}
      </div>

      {/* Mobile: thin single-row trust bar */}
      <div className="flex items-stretch justify-between bg-[#FFF5F5] px-4 py-3 md:hidden">
        {STATS_DATA.map((stat, index) => (
          <div key={index} className="flex flex-1 flex-col items-center gap-0.5 px-1 text-center">
            <stat.Icon className="h-4 w-4 text-primary" fill="currentColor" strokeWidth={1.5} />
            <p className="text-[13px] font-bold leading-[1.2] tracking-[-0.022em] text-[#4F4F4F]">{stat.value}</p>
            <p className="text-[10px] leading-[1.3] tracking-[-0.3px] text-[#8E8E8E]">{stat.shortLabel}</p>
          </div>
        ))}
      </div>

      <div className="mt-0 h-px w-full bg-[#EAEAEA]" />
    </div>
  );
}
